module.exports = __webpack_public_path__ + "static/img/59-3.11b59c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/59-3.jpg
// module id = vnVU
// module chunks = 0